import React from 'react';
import {
  Box,
  ButtonBase,
  Collapse,
  Typography,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import type { TApiCovenant } from '~/modules/covenants/types.ts';
import { clientStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/styles.ts';

interface ICovenantListItemProps {
  covenant: TApiCovenant;
  index: number;
  covenantsPage: number;
  covenantsPerPage: number;
  expandedCovenantIndex: number | null;
  onToggle: (index: number) => void;
}

export const CovenantListItem: React.FC<ICovenantListItemProps> = ({
  covenant,
  index,
  covenantsPage,
  covenantsPerPage,
  expandedCovenantIndex,
  onToggle,
}) => {
  const globalIndex = covenantsPage * covenantsPerPage + index;
  const isExpanded = expandedCovenantIndex === globalIndex;

  return (
    <Box sx={[clientStyles.covDialogItem, isExpanded && clientStyles.covDialogItemExpanded]}>
      <ButtonBase onClick={() => onToggle(globalIndex)} sx={clientStyles.covDialogItemButton}>
        <DescriptionOutlinedIcon sx={clientStyles.covDialogItemIcon} />

        <Box sx={clientStyles.covDialogItemMeta}>
          <Typography component="div" sx={clientStyles.covDialogItemTitle}>
            {covenant.id || '-'}
          </Typography>
          <Typography component="div" sx={clientStyles.covDialogItemSubtitle}>
            Контракт: {covenant.contactName || '-'}
          </Typography>
        </Box>

        {isExpanded ? (
          <KeyboardArrowUpIcon sx={clientStyles.covDialogItemChevron} />
        ) : (
          <KeyboardArrowDownIcon sx={clientStyles.covDialogItemChevron} />
        )}
      </ButtonBase>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box sx={clientStyles.covDialogItemDetails}>
          <Typography variant="body2" sx={clientStyles.covDialogItemDetailsText}>
            {covenant.name || '-'}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};
